import React from "react";
import { Link } from "react-router-dom";
import { Mail, Globe } from "lucide-react";
import AllinstraLogo from "./AllinstraLogo";

const FOOTER_GROUPS = [
  {
    title: "Solutions",
    links: [
      { to: "/solutions", label: "All Solutions" },
      { to: "/product-portfolio", label: "Product Portfolio" },
      { to: "/technology", label: "Technology" },
      { to: "/implementation", label: "Implementation" },
    ],
  },
  {
    title: "Company",
    links: [
      { to: "/about", label: "About Allinstra" },
      { to: "/markets", label: "Markets" },
      { to: "/contact", label: "Contact" },
      { to: "/sitemap", label: "Sitemap" },
    ],
  },
  {
    title: "Legal",
    links: [{ to: "/legal-center", label: "Legal Center" }],
  },
];

const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-ink-900 text-ink-300 border-t border-ink-800"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <AllinstraLogo variant="light" layout="icon" size={40} />
          <p className="mt-8 text-[15px] leading-relaxed text-ink-400 max-w-md">
            Digital management systems for municipalities, organized industrial zones,
            public-service organizations, and structured institutions that need clearer
            operations, stronger document control, and connected workflows.
          </p>
          <p className="mt-6 font-display text-2xl text-white tracking-tight">
            Bring order forward.
          </p>

          <div className="mt-10 space-y-3 text-sm">
            <a
              href="mailto:info@allinstra.com"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 text-ink-300 hover:text-cyan-300 transition-colors"
            >
              <Mail size={14} /> info@allinstra.com
            </a>
            <div className="flex items-center gap-2 text-ink-400">
              <Globe size={14} /> allinstra.com
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 grid grid-cols-3 gap-8">
          {FOOTER_GROUPS.map((group) => (
            <div key={group.title}>
              <div className="tag-overline" style={{ color: "#67E8F9" }}>
                {group.title}
              </div>
              <ul className="mt-5 space-y-3">
                {group.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                      className="footer-link text-sm text-ink-300 hover:text-white"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-ink-800 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="text-xs text-ink-400">
          © 2026 <span className="text-white">Erenown</span>. All rights reserved.{" "}
          <span className="text-white">Allinstra</span> is an institutional systems brand by
          <span className="text-white"> Erenown</span>.
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
